import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { Eye, X } from 'lucide-react';
import { LiveNumber } from './LiveNumber';
import { useLiveViewers } from '../hooks/useLiveViewers';
import { runWhenIdle } from '../utils/scheduling';
export function LiveViewersBadge() {
  const viewers = useLiveViewers();
  const reduceMotion = useReducedMotion();
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    const handle = runWhenIdle(() => setVisible(true));
    return handle.cancel;
  }, []);
  return <div className="pointer-events-none fixed right-3 top-14 z-50 flex justify-end sm:right-5 sm:top-16" data-id="element-166" data-mp="38yvoihks1wyn">
      <AnimatePresence data-id="element-167" data-mp="340kfg92b3qhh">
        {visible && !dismissed && <motion.div initial={{
        opacity: 0,
        x: reduceMotion ? 0 : 24,
        scale: reduceMotion ? 1 : 0.97
      }} animate={{
        opacity: 1,
        x: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        x: reduceMotion ? 0 : 24,
        scale: 0.98
      }} transition={{
        duration: reduceMotion ? 0.15 : 0.5,
        ease: [0.22, 1, 0.36, 1]
      }} className="pointer-events-auto flex items-center gap-3 rounded-2xl border border-gold-500/25 bg-noir-800/95 py-2.5 pl-3 pr-2.5 shadow-[0_18px_40px_-18px_rgba(0,0,0,0.95)] backdrop-blur-md" data-id="element-168" data-mp="1xljhxyxmv08s">
            <span aria-hidden="true" className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-crimson-600/15 ring-1 ring-crimson-500/35" data-id="element-169" data-mp="103elohq2tc3w">
              <Eye className="h-4 w-4 text-crimson-500" data-id="element-170" data-mp="r5vuswpr43k3" />
            </span>

            <div className="text-left" aria-live="polite" data-id="element-171" data-mp="cgzph7f2x4n6">
              <p className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-widest2 text-crimson-500" data-id="element-172" data-mp="hei0r4gkjvyc">
                <span className="h-1.5 w-1.5 rounded-full bg-crimson-500 animate-pulseDot" data-id="element-173" data-mp="3eqgwn3dflcf" />
                En vivo
              </p>
              <p className="mt-0.5 whitespace-nowrap text-[12px] text-cream/70" data-id="element-174" data-mp="7fsi39gum7h1">
                <LiveNumber value={viewers} className="font-bold text-cream" data-id="element-175" data-mp="2a40sl3mphi2w" /> personas
                viendo esta página
              </p>
            </div>

            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar contador de visitantes" className="ml-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-cream/35 transition-colors hover:bg-cream/10 hover:text-cream/70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-400" data-id="element-176" data-mp="20d66q0ddgkhz">
              <X className="h-3.5 w-3.5" aria-hidden="true" data-id="element-177" data-mp="2j3e3m0qhaepq" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}